export {Path, path, pathRound} from "./path.js";



//////////////////
// WEBPACK FOOTER
// ./~/d3-path/src/index.js
// module id = 110
// module chunks = 0